
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const PersonalBanking = lazy(() => import('../pages/services/personal-banking/page'));
const BusinessBanking = lazy(() => import('../pages/services/business-banking/page'));
const CreditCards = lazy(() => import('../pages/services/credit-cards/page'));
const HomeLoans = lazy(() => import('../pages/services/home-loans/page'));
const AutoLoans = lazy(() => import('../pages/services/auto-loans/page'));
const InvestmentServices = lazy(() => import('../pages/services/investment-services/page'));
const Rates = lazy(() => import('../pages/rates/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const JoinUs = lazy(() => import('../pages/join-us/page'));
const SignIn = lazy(() => import('../pages/sign-in/page'));
const ClientDashboard = lazy(() => import('../pages/dashboard/client/page'));
const AdminDashboard = lazy(() => import('../pages/dashboard/admin/page'));
const AdminReset = lazy(() => import('../pages/admin-reset/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/services/personal-banking',
    element: <PersonalBanking />
  },
  {
    path: '/services/business-banking',
    element: <BusinessBanking />
  },
  {
    path: '/services/credit-cards',
    element: <CreditCards />
  },
  {
    path: '/services/home-loans',
    element: <HomeLoans />
  },
  {
    path: '/services/auto-loans',
    element: <AutoLoans />
  },
  {
    path: '/services/investment-services',
    element: <InvestmentServices />
  },
  {
    path: '/rates',
    element: <Rates />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/join-us',
    element: <JoinUs />
  },
  {
    path: '/sign-in',
    element: <SignIn />
  },
  {
    path: '/dashboard/client',
    element: <ClientDashboard />
  },
  {
    path: '/dashboard/admin',
    element: <AdminDashboard />
  },
  {
    path: '/admin-reset',
    element: <AdminReset />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
